'use client';

import { c as _c } from "react/compiler-runtime";
import './volunteer-filter.scss';
import { Badge } from '@sola/ark-core/atoms/badge/badge.tsx';
import { Prominence, Sizes, Text, Variants } from '@sola/ark-core/atoms/text/text.tsx';
import { ComboboxField } from '@sola/ark-core/molecules/combobox-field/combobox-field.tsx';
import type { GeoLocationDto } from '@sola/skippy-search-sdk/lib/schema.ts';
import { GeoLookupField } from '../geo-lookup-field/geo-lookup-field.tsx';
import type { ResolvedLocation } from './volunteer-controls.logic.ts';
import { useVolunteerFilter } from './volunteer-filter.logic.ts';
export const VolunteerFilter = t0 => {
  const $ = _c(44);
  const {
    volunteerCount,
    limit,
    defaultLocation,
    onGeoChange,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== defaultLocation || $[1] !== limit || $[2] !== onGeoChange) {
    t2 = {
      limit,
      defaultLocation,
      onGeoChange
    };
    $[0] = defaultLocation;
    $[1] = limit;
    $[2] = onGeoChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    t,
    locationInput,
    sortInput,
    sortByOptions,
    listTitle,
    handleSortSelect,
    handleLocationValueChange,
    handleGeoChange,
    handleLocationSubmit
  } = useVolunteerFilter(t2);
  const t3 = variant === "tour" ? Sizes.Medium : Sizes.Large;
  let t4;
  if ($[4] !== listTitle || $[5] !== t || $[6] !== variant) {
    t4 = variant === "tour" ? t("volunteers:volunteerOpportunities") : listTitle;
    $[4] = listTitle;
    $[5] = t;
    $[6] = variant;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <h2>{t4}</h2>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <Text variant={Variants.Heading} size={t3} prominence={Prominence.Amplified} asChild={true}>{t5}</Text>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t || $[14] !== variant || $[15] !== volunteerCount) {
    t7 = variant === "tour" && volunteerCount && <Badge label={t("volunteers:locationWithCount", {
      count: volunteerCount
    })} size="sm" color="brand" />;
    $[13] = t;
    $[14] = variant;
    $[15] = volunteerCount;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="VolunteerFilter__heading body-md flex flex-row items-center gap-comfy-xs">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== handleGeoChange || $[21] !== handleLocationSubmit || $[22] !== handleLocationValueChange || $[23] !== locationInput) {
    t9 = <GeoLookupField value={locationInput} onValueChange={handleLocationValueChange} onGeoChange={handleGeoChange} onSubmit={handleLocationSubmit} className="flex-1" />;
    $[20] = handleGeoChange;
    $[21] = handleLocationSubmit;
    $[22] = handleLocationValueChange;
    $[23] = locationInput;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t) {
    t10 = t("volunteers:sortByPrefix");
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = `${t10}: `;
  let t12;
  if ($[27] !== t) {
    t12 = t("volunteers:sortLocationsBy");
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("volunteers:sortLocationsBy");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== handleSortSelect || $[32] !== sortByOptions || $[33] !== sortInput || $[34] !== t11 || $[35] !== t12 || $[36] !== t13) {
    t14 = <ComboboxField variant="select" value={sortInput} onSelect={handleSortSelect} items={sortByOptions} selectedPrefix={t11} placeholder={t12} aria-label={t13} name="sort" minChars={0} className="flex-1" />;
    $[31] = handleSortSelect;
    $[32] = sortByOptions;
    $[33] = sortInput;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t14 || $[39] !== t9) {
    t15 = <div className="flex flex-col lg:align-center md:flex-row lg:justify-end gap-comfy-sm flex-wrap">{t9}{t14}</div>;
    $[38] = t14;
    $[39] = t9;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t15 || $[42] !== t8) {
    t16 = <div className="VolunteerFilter pb-comfy-lg"><div className="VolunteerFilter__container flex flex-col lg:flex-row lg:justify-between lg:align-end gap-comfy-lg">{t8}{t15}</div></div>;
    $[41] = t15;
    $[42] = t8;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  return t16;
};